// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"561d5dad","215":"13c10c1f"}[chunkId] + ".chunk.js";
};